export function dismissAlert() {
  return {
    type: "DISMISS_ALERT"
  };
}

export function changeGender(gender) {
  return {
    type: "CHANGE_GENDER",
    value: gender.target.value
  };
}

// change height
export function changeHeight(height) {
  return {
    type: "CHANGE_HEIGHT",
    value: height
  };
}

// change weight
export function changeWeight(weight) {
  return {
    type: "CHANGE_WEIGHT",
    value: weight
  };
}

// show/hide car seat values
export function toggleCarSeats(event) {
  return {
    type: "TOGGLE_CAR_SEATS",
    value: event
  };
}

// show/hide car seat values
export function toggleClothingBrands(event) {
  return {
    type: "TOGGLE_CLOTHING_BRANDS",
    value: event
  };
}

export function updateSelectedClothingBrands(brand) {
  return {
    type: "CHANGE_SELECTED_CLOTHING_BRAND",
    key: brand.target.name,
    value: brand.target.checked
  };
}

export function updateSelectedCarSeatBrands(brand) {
  return {
    type: "CHANGE_SELECTED_CAR_SEAT_BRAND",
    key: brand.target.name,
    value: brand.target.checked
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/actionCreators.js
 **/